import { Hero } from "../components/sections/Hero";
import { Ticker } from "../components/Ticker";
import { AboutBEA } from "../components/sections/AboutBEA";
import { Accreditations } from "../components/sections/Accreditations";
import { Academics } from "../components/sections/Academics";
import { DirectorMessage } from "../components/sections/DirectorMessage";
import { Events } from "../components/sections/Events";
import { FeaturedNews } from "../components/sections/FeaturedNews";
import { CampusLife } from "../components/sections/CampusLife";
import { Alumni } from "../components/sections/Alumni";
import { VisitorsStrip } from "../components/sections/Visitors";
import { CtaStrip } from "../components/sections/CtaStrip";

export default function Home() {
  return (
    <>
      {/* Appearance is fixed to the Poster hero — its own fact rail (1979, 63
          acres, the UG + PG count, autonomous since 2024) covers what the
          Stats band elsewhere restates, so this page doesn't need Stats too. */}
      <Hero variant="D" />
      <Ticker />
      <AboutBEA />
      {/* "Our charter" (VisionMission) is hidden from the home page by request —
          the component is untouched, just not mounted here. */}
      <Accreditations />
      <Academics />
      <DirectorMessage />
      <CampusLife />
      <Events />
      <FeaturedNews />
      <Alumni />
      <VisitorsStrip />
      {/* Placement teaser removed from the home page for now — the
          Recruiters component is untouched, just not mounted here. */}
      <CtaStrip />
    </>
  );
}
